// Gradients taken from: https://webgradients.com/
export default [
  {
    name: 'yume1',
    description: '#a8edea → #fed6e3',
    css:
      `url(${require("envato/3d-rendering-beautiful-small-bedroom-with-nice-dec-2RNRNZ5.jpg")})`,
    // css: 'linear-gradient(to top, #a8edea 0%, #fed6e3 100%)',
    height: 200
  },
  {
    name: 'Saint Petersburg',
    description: '#f5f7fa → #c3cfe2',
    css:
      `url(${require("envato/3d-rendering-modern-classic-bathroom-with-luxury-t-KFHCU6G.jpg")})`,
    // css: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    height: 400
  },
  {
    name: 'Deep Blue',
    description: '#e0c3fc → #8ec5fc',
    css:
      `url(${require("envato/3d-rendering-modern-house-with-terrace-at-night-82BV93Z.jpg")})`,
    // css: 'linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%)',
    height: 400
  },
  {
    name: 'yume2',
    description: '#f093fb → #f5576c',
    css:
      'url(./envato/3d-rendering-modern-minimal-bathroom-with-scandina-4Z3QP5P.jpg)',
    // css: 'linear-gradient(120deg, #f093fb 0%, #f5576c 100%)',
    height: 400
  },
  {
    name: 'Perfect White',
    description: '#fdfbfb → #ebedee',
    css:
      'url(./envato/8.jpg)',
    // css: 'linear-gradient(-225deg, #E3FDF5 0%, #FFE6FA 100%)',
    height: 400
  },
  {
    name: 'Near Moon',
    description: '#5ee7df → #b490ca',
    css:
      'url(./envato/back0.jpg)',
    // css: 'linear-gradient(to top, #5ee7df 0%, #b490ca 100%)',
    height: 400
  },
  {
    name: 'Wild Apple',
    description: '#d299c2 → #fef9d7',
    css:
      'url(./envato/back1.jpg)',
    // css: 'linear-gradient(to top, #d299c2 0%, #fef9d7 100%)',
    height: 200
  },
  {
    name: 'Ladoga Bottom',
    description: '#ebc0fd → #d9ded8',
    css:
      'url(./envato/back2.jpg)',
    // css: 'linear-gradient(to top, #ebc0fd 0%, #d9ded8 100%)',
    height: 400
  },
  {
    name: 'Sunny Morning',
    description: '#f6d365 → #fda085',
    css:
      'url(./envato/back3.jpg)',
    // css: 'linear-gradient(120deg, #f6d365 0%, #fda085 100%)',
    height: 200
  },
  {
    name: 'Lemon Gate',
    description: '#96fbc4 → #f9f586',
    css:
      'url(./envato/3d-rendering-beautiful-small-bedroom-with-nice-dec-2RNRNZ5.jpg)',
    // css: 'linear-gradient(to top, #96fbc4 0%, #f9f586 100%)',
    height: 400
  },
  {
    name: 'Salt Mountain',
    description: ' #FFFEFF → #D7FFFE',
    css:
      'url(./envato/3d-rendering-beautiful-small-bedroom-with-nice-dec-2RNRNZ5.jpg)',
    // css: 'linear-gradient(-225deg, #FFFEFF 0%, #D7FFFE 100%)',
    height: 200
  },
  {
    name: 'New York',
    description: ' #fff1eb → #ace0f9',
    css:
      'url(./envato/3d-rendering-beautiful-small-bedroom-with-nice-dec-2RNRNZ5.jpg)',
    // css: 'linear-gradient(to top, #fff1eb 0%, #ace0f9 100%)',
    height: 400
  },
  {
    name: 'Soft Grass',
    description: ' #c1dfc4 → #deecdd',
    css:
      'url(./envato/3d-rendering-beautiful-small-bedroom-with-nice-dec-2RNRNZ5.jpg)',
    // css: 'linear-gradient(to top, #c1dfc4 0%, #deecdd 100%)',
    height: 400
  },
  {
    name: 'Japan Blush',
    description: ' #ddd6f3 → #faaca8',
    css:
      'url(./envato/3d-rendering-beautiful-small-bedroom-with-nice-dec-2RNRNZ5.jpg)',
    // css: 'linear-gradient(-20deg, #ddd6f3 0%, #faaca8 100%, #faaca8 100%)',
    height: 200
  }
]
